import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=ea28ccf0&"
import script from "./OptionGroup.vue?vue&type=script&lang=ts&"
export * from "./OptionGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OptionGroup.vue"
export default component.exports